<template>
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-show-upsell-items-modal"
      data-bs-toggle="modal"
      data-bs-target="#modal_upsell_items"
    ></button>
    <button
      style="display: none"
      type="button"
      class="btn-hide-upsell-items-modal"
      data-bs-dismiss="modal"
      data-bs-target="#modal_upsell_items"
    ></button>

    <div
      class="modal fade"
      id="modal_upsell_items"
      tabindex="-1"
      aria-labelledby="modal_upsell_items"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <!-- Loading overlay -->
          <material-loading :active="isLoading" />

          <div class="modal-body">
            <!-- Header -->
            <div class="modal-header-custom">
              <h4 class="modal-title">Popular items you might like to add:</h4>
            </div>

            <!-- Content Area -->
            <div class="upsell-items-container">
              <div class="upsell-items-list">
                <div
                  v-for="upsellItem in upsellItems"
                  :key="upsellItem.item.id"
                  class="upsell-item-row"
                >
                  <!-- Item Image -->
                  <div class="item-image-container">
                    <img
                      :src="upsellItem.item.image"
                      alt="item image"
                      class="item-image"
                    />
                  </div>

                  <!-- Item Details -->
                  <div class="item-details">
                    <div class="item-name">{{ upsellItem.item.item_name }}</div>
                    <span
                      class="item-description"
                      v-if="upsellItem.item.description"
                    >{{ upsellItem.item.description }}</span>

                    <div class="item-bottom-row">
                      <span
                        v-if="upsellItem.item.member_price && upsellItem.item.member_price !== upsellItem.item.price_default"
                        class="price-wrap"
                      >
                        <span class="original-price">$ {{ formatPrice(upsellItem.item.price_default) }}</span>
                        <span class="member-price">$ {{ formatPrice(upsellItem.item.member_price) }}</span>
                      </span>
                      <span v-else class="price">$ {{ formatPrice(upsellItem.item.price_default) }}</span>

                      <div class="quantity-selector">
                        <button
                          class="quantity-btn minus-btn"
                          @click="decreaseQuantity(upsellItem)"
                        >
                          -
                        </button>
                        <span class="quantity-display">{{ getItemQuantity(upsellItem) }}</span>
                        <button
                          class="quantity-btn plus-btn"
                          @click="increaseQuantity(upsellItem)"
                        >
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Footer Buttons -->
            <div class="modal-footer-custom d-flex justify-content-center">
              <material-button
                class="btn-no-thanks w-50"
                @click="closeModal"
                :disabled="isLoading"
              >
                NO, THANKS
              </material-button>
              <material-button
                class="btn-continue w-50"
                @click="continueWithSelection"
                :disabled="isLoading"
              >
                ADD TO CART
              </material-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Snackbar for notifications -->
    <div class="position-fixed top-1 end-1 z-index-2 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import { localStorageName } from "@/config/utils";
import $ from "jquery";

export default {
  name: "ModalUpsellItems",
  components: {
    MaterialButton,
    MaterialSnackbar,
    MaterialLoading,
  },
  props: {
    upsellItems: {
      type: Array,
      required: true,
      default: () => []
    },
  },
  data() {
    return {
      snackbar: null,
      message: "",
      merchantCode: "",
      branchCode: "",
      cartName: "",
      branch: JSON.parse(
        localStorage.getItem(localStorageName("BRANCH_INFO"), "")
      ),
      selectedUpsellItems: [],
      isLoading: false,
    };
  },
  computed: {
    selectedItemsMap() {
      const map = new Map();
      this.selectedUpsellItems.forEach(item => {
        map.set(item.item.id, item.quantity);
      });
      return map;
    }
  },
  async mounted() {
    this.merchantCode = this.$store.state.merchantCode;
    this.branchCode = this.$store.state.branchCode;
    this.cartName = await this.$store.dispatch("cartName");

    // Reset selected items when component is mounted
    this.resetSelectedItems();

    // Listen for modal events to handle loading
    this.$nextTick(() => {
      const modal = document.getElementById('modal_upsell_items');
      if (modal) {
        modal.addEventListener('show.bs.modal', this.onModalShow);
        modal.addEventListener('hidden.bs.modal', this.onModalHidden);
      }
    });
  },
  beforeUnmount() {
    // Clean up event listeners
    const modal = document.getElementById('modal_upsell_items');
    if (modal) {
      modal.removeEventListener('show.bs.modal', this.onModalShow);
      modal.removeEventListener('hidden.bs.modal', this.onModalHidden);
    }
  },
  methods: {
    closeSnackbar() {
      this.snackbar = null;
    },
    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
    showLoader() {
      this.isLoading = true;
    },
    hideLoader() {
      this.isLoading = false;
    },
    onModalShow() {
      // Show loading when modal opens
      this.showLoader();
      // Simulate loading time for better UX
      setTimeout(() => {
        this.hideLoader();
      }, 300);
    },
    onModalHidden() {
      // Hide loading when modal closes
      this.hideLoader();
      // Reset selected items when modal closes
      this.resetSelectedItems();
    },
    closeModal() {
      // Emit event to parent to handle navigation to my-cart
      this.$emit('no-thanks-clicked');
      // Close modal
      $(".btn-hide-upsell-items-modal").click();
    },
    async continueWithSelection() {
      try {
        this.showLoader();

        // Check if any items have been increased in quantity
        const hasItemsWithQuantity = this.selectedUpsellItems.some(item => item.quantity > 0);

        if (!hasItemsWithQuantity) {
          // Show error message if no items have been selected
          this.snackbar = 'danger';
          this.message = 'Please select at least one item before continuing!';
          this.setTimeOutNotification();
          return;
        }

        // Add selected items to cart using localStorage (same as kiosk modal)
        const cartName = this.cartName;
        let orderInfo = JSON.parse(localStorage.getItem(cartName, null)) ?? [];

        // IMPORTANT: Logic for handling duplicate items (same as kiosk)
        // - If item with same ID AND same price exists: increase quantity
        // - If item with same ID but different price exists: add as new item
        // This prevents issues with items that have same ID but different pricing (promotions, etc.)

        // Add each selected upsell item to cart
        this.selectedUpsellItems.forEach(upsellItem => {
          if (upsellItem.quantity > 0) {
            // Check if item already exists in cart with same ID AND same price
            const existingItemIndex = this.findExistingItemInCart(
              orderInfo,
              upsellItem.item.id,
              upsellItem.item.price_default
            );

            if (existingItemIndex > -1) {
              // Update quantity if item exists with same price
              orderInfo[existingItemIndex].quantity += upsellItem.quantity;
            } else {
              // Add new item to cart - use the correct structure (same as kiosk)
              const itemToAdd = {
                id: upsellItem.item.id,
                choice:  upsellItem.item.choice,
                choices: upsellItem.item.choices,
                item_name: upsellItem.item.item_name,
                item_no: upsellItem.item.item_no,
                description: upsellItem.item.description,
                price_default: parseFloat(upsellItem.item.price_default),
                price_default_no_modifier_option: parseFloat(upsellItem.item.price_default),
                member_price: parseFloat(upsellItem.item.member_price || upsellItem.item.price_default),
                member_price_no_modifier_option: parseFloat(upsellItem.item.member_price || upsellItem.item.price_default),
                quantity: upsellItem.quantity,
                // Add other necessary fields that cart expects
                category_id: upsellItem.item.category_id || 0,
                menuset_id: upsellItem.item.menuset_id || 0,
                branch_code: this.branchCode,
                // Add image if available
                image: upsellItem.item.image || null,
                // Add source identifier to distinguish upsell items
                source: 'upsell'
              };
              orderInfo.push(itemToAdd);
            }
          }
        });

        // Save updated cart to localStorage
        localStorage.setItem(cartName, JSON.stringify(orderInfo));

        // Emit selected items to parent component
        this.$emit('upsell-items-selected', this.selectedUpsellItems.filter(item => item.quantity > 0));

        // Close modal
        $(".btn-hide-upsell-items-modal").click();
      } catch (error) {
        console.error('Error in continueWithSelection:', error);
        this.snackbar = 'danger';
        this.message = 'An error occurred while processing your request.';
        this.setTimeOutNotification();
      } finally {
        this.hideLoader();
      }
    },
    getItemQuantity(upsellItem) {
      return this.selectedItemsMap.get(upsellItem.item.id) || 0;
    },
    increaseQuantity(upsellItem) {
      // Prevent infinite loops by checking if item already exists (same as kiosk)
      const existingItem = this.selectedUpsellItems.find(item => item.item.id === upsellItem.item.id);
      if (existingItem) {
        // Limit maximum quantity to prevent excessive increases
        if (existingItem.quantity < 99) {
          existingItem.quantity++;
        }
      } else {
        this.selectedUpsellItems.push({ ...upsellItem, quantity: 1 });
      }
    },
    decreaseQuantity(upsellItem) {
      const itemIndex = this.selectedUpsellItems.findIndex(item => item.item.id === upsellItem.item.id);
      if (itemIndex > -1) {
        if (this.selectedUpsellItems[itemIndex].quantity > 1) {
          this.selectedUpsellItems[itemIndex].quantity--;
        } else {
          // Remove item when quantity reaches 0
          this.selectedUpsellItems.splice(itemIndex, 1);
        }
      }
    },
    resetSelectedItems() {
      this.selectedUpsellItems = [];
    },
    handleImageError(event) {
      // Set default image when image fails to load
      event.target.src = '/src/assets/img/noimage.png';
    },
    formatPrice(price) {
      return parseFloat(price).toFixed(2);
    },
    checkAndReturnPopular(tags) {
      if (tags && tags.length > 0) {
        if (tags.includes("Popular")) {
          return "Popular";
        }
      }
      return "";
    },
    checkAndReturnSignature(tags) {
      if (tags && tags.length > 0) {
        if (tags.includes("Signature")) {
          return "Signature";
        }
      }
      return "";
    },

    // Helper method to check if item exists in cart with same price (same as kiosk)
    findExistingItemInCart(cartItems, itemId, price) {
      return cartItems.findIndex(item =>
        item.id === itemId &&
        parseFloat(item.price_default) === parseFloat(price)
      );
    },
  },
};
</script>

<style scoped>
.modal {
  overflow-y: hidden;
}

.modal-dialog {
  max-width: 460px;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  max-height: 90vh;
}

.modal-content {
  border-radius: 24px;
  border: none;
  overflow: hidden;
  background: var(--theme-30, #f7f4ef);
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.22);
}

.modal-body {
  padding: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* Header */
.modal-header-custom {
  padding: 22px 22px 10px;
  border-bottom: none;
  background: transparent;
}

.modal-title {
  font-family: "Inter", sans-serif;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: #201a1a;
  margin: 0;
  text-align: center;
}

/* Content Area */
.upsell-items-container {
  flex: 1;
  overflow-y: auto;
  padding: 6px 16px;
  max-height: 60vh;
}

.upsell-items-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.upsell-item-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 16px;
}

/* Item Image */
.item-image-container {
  flex-shrink: 0;
}

.item-image {
  width: 76px;
  height: 76px;
  object-fit: cover;
  border-radius: 14px;
  border: none;
  display: block;
}

/* Item Details */
.item-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.item-name {
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.25;
  color: #201a1a;
}

.item-description {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #857372;
  line-height: 1.3;
}

.item-bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 4px;
  gap: 10px;
}

.price-wrap {
  display: inline-flex;
  align-items: baseline;
  gap: 6px;
}

.price,
.original-price,
.member-price {
  font-family: "Inter", sans-serif;
  font-weight: 700;
}

.price {
  font-size: 15px;
  color: #201a1a;
}

.original-price {
  font-size: 12px;
  text-decoration: line-through;
  color: #a79e97;
  font-weight: 500;
}

.member-price {
  font-size: 15px;
  color: var(--color);
}

/* Quantity Selector — pill stepper (matches the item-detail modal) */
.quantity-selector {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  padding: 4px;
  border-radius: 999px;
  background: #f2ece5;
}

.quantity-btn {
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  cursor: pointer;
  transition: transform 0.12s ease, background 0.15s ease, color 0.15s ease;
  color: var(--color);
}

.quantity-btn:hover:not(:disabled) {
  background-color: var(--color);
  color: #fff;
}

.quantity-btn:active {
  transform: scale(0.9);
}

.quantity-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  color: #ccc;
}

.quantity-display {
  font-family: "Inter", sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #201a1a;
  min-width: 20px;
  text-align: center;
}

/* Footer */
.modal-footer-custom {
  padding: 14px 16px 20px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  background: transparent;
  gap: 12px;
}

.btn-no-thanks,
.btn-continue {
  flex: 1;
  height: 48px;
  padding: 0 16px !important;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border-radius: 999px !important;
  transition: transform 0.12s ease, background 0.15s ease, color 0.15s ease;
}

.btn-no-thanks {
  background: transparent !important;
  color: var(--color) !important;
  border: 1.5px solid var(--color) !important;
  box-shadow: none !important;
}

.btn-no-thanks:hover:not(:disabled) {
  background: var(--color) !important;
  color: #fff !important;
}

.btn-continue {
  background: var(--color) !important;
  color: #fff !important;
  border: 1.5px solid var(--color) !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.14) !important;
}

.btn-continue:active,
.btn-no-thanks:active {
  transform: scale(0.98);
}

/* Scrollbar */
.upsell-items-container::-webkit-scrollbar {
  width: 6px;
}

.upsell-items-container::-webkit-scrollbar-track {
  background: transparent;
}

.upsell-items-container::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.15);
  border-radius: 3px;
}

.upsell-items-container::-webkit-scrollbar-thumb:hover {
  background: var(--color);
}

/* Responsive */
@media (max-width: 768px) {
  .modal-dialog {
    width: 95%;
  }
}

/* Loading overlay */
.material-loading {
  z-index: 1056;
}

/* Z-index for snackbar */
.z-index-2 {
  z-index: 9999 !important;
}
</style>